<template>
  <div class="container">
    <page-content />
    <map-content v-if="hasmap" />
  </div>
</template>

<script>
import request from "@/util/request";
const pageContent = () => import("./page/homePage");
const mapContent = () => import("./map/map");
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["hasmap", "seleIndex"])
  },
  components: { pageContent, mapContent },
  created() {
    const { code, client_id } = this.$route.query;
    console.log("has ", code, client_id);
    if (code && client_id) {
      this.getData(code, client_id);
    }
  },
  methods: {
    getData(code, client_id) {
      request({
        // url: '/auth/directLoginNocode',
        url: "/api/sso/login",
        method: "get",
        params: {
          code,
          client_id
        }
      }).then(res => {
        console.log("sso login res ==", res);
        const token = res.token;
        // const user = res.user
        if (!token) {
          return;
        }
        this.$store.dispatch("mdLogin", res).then(() => {
          console.log("save user info ok");
        });
        // todo 页面跳转
        // this.$router.replace(`/dashboard?token=${token}`)
      });
    }
  },
  mounted() {
    if (this.seleIndex > -1) {
      this.$bus.$emit("onNavChage", this.seleIndex);
    }
  }
};
</script>

<style lang="stylus" scoped>
.container
  width 100%
  height 100vh
  background url('~images/bg.png') no-repeat center
  background-size 100% 100%
  position relative
  overflow hidden
</style>
